(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    window.vinciCartDrawerAssetsReady = true;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-protection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-protection')) {
    customElements.define(
      'shipping-protection',
      class ShippingProtection extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('input[type="checkbox"]');
          this.errorElement = this.querySelector('.shipping-protection__error');
          this.checkbox?.addEventListener('change', this.onChange.bind(this));

          if (this.checkbox?.checked) {
            const currentVariantId = Number(this.dataset.currentVariantId || 0);
            const targetVariantId = Number(this.dataset.targetVariantId || 0);
            const currentQuantity = Number(this.dataset.currentQuantity || 0);
            if (currentVariantId !== targetVariantId || currentQuantity !== 1) this.syncSelectedProtection();
          }
        }

        async onChange() {
          if (this.checkbox.checked) {
            await this.syncSelectedProtection();
          } else {
            await this.removeProtection();
          }
        }

        async syncSelectedProtection() {
          const currentLineKey = this.dataset.currentLineKey;
          const currentVariantId = Number(this.dataset.currentVariantId || 0);
          const targetVariantId = Number(this.dataset.targetVariantId || 0);
          const currentQuantity = Number(this.dataset.currentQuantity || 0);

          if (!targetVariantId) return;

          try {
            this.setBusy(true);
            if (currentLineKey && currentVariantId === targetVariantId) {
              if (currentQuantity !== 1) await this.changeLine(currentLineKey, 1);
            } else {
              if (currentLineKey) await this.changeLine(currentLineKey, 0, false);
              await this.addVariant(targetVariantId);
            }
          } catch (error) {
            this.showError();
            if (this.checkbox) this.checkbox.checked = false;
            console.error(error);
          } finally {
            this.setBusy(false);
          }
        }

        async removeProtection() {
          const currentLineKey = this.dataset.currentLineKey;
          if (!currentLineKey) return;

          try {
            this.setBusy(true);
            await this.changeLine(currentLineKey, 0);
          } catch (error) {
            this.showError();
            if (this.checkbox) this.checkbox.checked = true;
            console.error(error);
          } finally {
            this.setBusy(false);
          }
        }

        async addVariant(variantId) {
          return this.request(routes.cart_add_url, {
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: { _vinci_shipping_protection: 'true' },
              },
            ],
          });
        }

        async changeLine(lineKey, quantity, render = true) {
          return this.request(routes.cart_change_url, { id: lineKey, quantity }, render);
        }

        async request(url, payload, render = true) {
          const sections = ['main-cart-items', 'main-cart-footer', 'cart-drawer', 'cart-icon-bubble'];
          const response = await fetch(url, {
            ...fetchConfig(),
            body: JSON.stringify({
              ...payload,
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();
          if (!response.ok || state.errors) throw new Error(state.description || state.message || state.errors);
          if (render && state.sections) this.renderSections(state.sections);
          return state;
        }

        renderSections(sections) {
          const replacements = [
            ['main-cart-items', '#main-cart-items', 'replace'],
            ['main-cart-footer', '#main-cart-footer', 'replace'],
            ['cart-icon-bubble', '#cart-icon-bubble', 'replace'],
            ['cart-drawer', '#CartDrawer', 'contents'],
          ];

          replacements.forEach(([sectionName, selector, mode]) => {
            const html = sections[sectionName];
            const current = document.querySelector(selector);
            if (!html || !current) return;

            const next = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
            if (!next) return;

            if (mode === 'contents') {
              current.innerHTML = next.innerHTML;
            } else {
              current.replaceWith(next);
            }
          });
        }

        setBusy(isBusy) {
          this.setAttribute('aria-busy', String(isBusy));
          if (this.checkbox) this.checkbox.disabled = isBusy;
          document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach((button) => {
            button.disabled = isBusy;
          });
        }

        showError() {
          if (!this.errorElement) return;
          this.errorElement.textContent = this.dataset.errorMessage;
          this.errorElement.hidden = false;
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
